import { Component, Input } from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import { RouterLink } from '@angular/router';
import { MatAnchor } from '@angular/material/button';
import { MatToolbar } from '@angular/material/toolbar';
import { TooltipPosition } from '../tooltip/tooltip.enums';
import { MatTooltipModule } from '@angular/material/tooltip';

@Component({
  selector: 'app-button-link-list',
  standalone: true,
  imports: [MatToolbar, MatAnchor, RouterLink, MatIcon, MatTooltipModule],
  templateUrl: './button-link-list.component.html',
  styleUrl: './button-link-list.component.scss',
})
export class ButtonLinkListComponent {
  @Input() user: any;
  @Input() title: string = '';
  @Input() linkToPageButtons: {
    name: string;
    img: string;
    link: string;
    authorizeGroup: string;
    tooltipMessage?: string;
    external?: boolean;
  }[] = [];
  protected readonly TooltipPosition = TooltipPosition;

  isEmptyOrNull(value: string): boolean {
    return value === null || value === '';
  }
}
